
var $ = require("../lib/jquery-1.11.2.mod.js");
var jQuery = $;
var console = require("../lib/logger.js");
var JSON = require("../lib/json3.mod.js");

var root = {};

function EngineHelper () {

    var me = this;
/*
    $(function () {

        $("body").append("<div id='TMPwmHiddenDiv'></div>");

        me._callbackHandlerWrapper = function (event) {

            if (me._callbackHandler != null) {

                me._callbackHandler(event);
            }
        };

        $("#TMPwmHiddenDiv").on("EngineCallbackEvent", me._callbackHandlerWrapper);
    });
*/

    root._$PWMCallback = function (event) {

        if (me._callbackHandler != null) {

            me._callbackHandler(event);
        }
    };
}

EngineHelper.prototype._callbackHandlerWrapper = function () {};

EngineHelper.prototype._callbackHandler = function () {};

EngineHelper.prototype.evaluateScript = function (scriptString) {

    try {

        eval(scriptString);

    } catch(e) {
        //log error;
    }

    return this;
};

EngineHelper.prototype.setCallbackHandler = function (callbackHandler) {

    if (typeof callbackHandler === "function") {

        this._callbackHandler = callbackHandler;
    }

    return this;
};

module.exports = EngineHelper;